/**
 * Theme Reducer
 * Manages theme state (light/dark mode)
 */

import { TOGGLE_THEME, SET_THEME } from '../actions/themeActions';

// Get initial theme from localStorage or default to dark
const getInitialTheme = () => {
  if (typeof window === 'undefined') return 'dark';
  const saved = localStorage.getItem('theme-mode');
  return saved || 'dark';
};

const initialState = {
  mode: getInitialTheme(),
};

/**
 * Theme reducer
 */
const themeReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_THEME:
    case SET_THEME:
      return {
        ...state,
        mode: action.payload,
      };
    default:
      return state;
  }
};

export default themeReducer;
